import moment from 'moment';

import { ApplicationInstance } from './Application.model';
import { Product } from './Product.model';
import { Session } from './Session.model';

const tempSession: Session = {
  iid: '0',
  username: '',
  template: ApplicationInstance(Product.TELEOPHTH).templates[0],
  id: '',
  firstName: '',
  lastName: '',
  age: undefined,
  date: moment().format('YYYY-MM-DD'),
  time: moment().format('HH:mm:ss'),
  leftImageFile: undefined,
  rightImageFile: undefined,
  graded: false,
  leftResults: [],
  rightResults: [],
  createdAt: new Date(),

  completedTime: undefined,
  completedReason: undefined,

  leftImageFileName: '',
  rightImageFileName: '',

  sessionId: '',
  practiceUserId: '',
};

export const initData = {
  tempSession,
};
